
import { ElMessage } from "element-plus/lib/components"
import router from '@/router/index.js'
import util from '@/utils/util'

/**
 * 向 /connect/token 发起一次 OAuth 密码登录请求。
 * @param {object} requestParams - 已完成密码加密的请求参数
 * @returns {Promise<object>} - 成功时 resolve token 数据，失败时 reject 错误对象
 */
function _doLoginRequest(requestParams) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", process.env.VUE_APP_BASEURL + "connect/token", true);
    xhr.timeout = 1000 * 5;
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');

    let rets = '';
    for (let it in requestParams) {
      rets += encodeURIComponent(it) + '=' + encodeURIComponent(requestParams[it]) + '&';
    }
    rets = rets.substring(0, rets.lastIndexOf('&'));

    xhr.send(rets);
    xhr.onload = function () {
      let data = {};
      if ((xhr.responseText || '').length > 1) data = JSON.parse(xhr.responseText);

      if (xhr.readyState == 4 && xhr.status == 200) {
        sessionStorage.clear();
        sessionStorage.setItem("access_token", data.access_token);
        sessionStorage.setItem("token_type", data.token_type);
        resolve(data);
      } else {
        reject(data);
      }
    };

    xhr.ontimeout = function () {
      xhr.abort();
      reject({ error_description: '接口请求超时' });
    };

    xhr.onerror = function () {
      xhr.abort();
      reject({ error_description: '接口请求失败' });
    };
  });
}

export async function login(params) {
  return _doLoginRequest({ ...params });
}

export function getInfo(token) {
}

export function logout() {
  sessionStorage.clear();
  localStorage.clear();
  ElMessage.warning('您已成功退出~');
  router.push("/login");
}
